import events from 'events.js';
import ko from 'knockout';

import 'ko/bindings/stop_binding.js';
import 'ko/bindings/tooltip.js';

(async function () {
    await events.ready();
    const headerElem = document.querySelector('[data-header="top"]');
    const headerElemPosition = headerElem.offsetTop;
    for (const elem of Array.from(
        document.getElementsByClassName('section-links'),
    )) {
        events.listen(elem, 'click', function () {
            const contentId = elem.id.replace('nav', 'content');
            const contentElem = document.getElementById(contentId);
            for (const e of Array.from(
                document.getElementsByClassName('main-content'),
            )) {
                e.classList.remove('hide');
                e.classList.add('hide');
            }
            contentElem.classList.remove('hide');
            for (const e of Array.from(
                document.getElementsByClassName('section-links'),
            )) {
                e.classList.remove('active');
            }
            elem.classList.add('active');
            if (window.pageYOffset > headerElemPosition) {
                headerElem.scrollIntoView();
            }
        });
    }
    const hash = document.location.hash;
    if (hash) {
        const decoded = decodeURI(hash);
        const hashElem = document.getElementById(
            `${decoded.replace('#', '')}-nav`,
        );
        if (hashElem) {
            events.trigger(hashElem, 'click');
        }
    }
    ko.applyBindings(null);
})();
